/* react-renderer.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"];
import "./react-renderer.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { Fragment, memo, Suspense, useMemo } from 'react';
import { Box } from '@atlaskit/primitives/compiled';
import { encodeAdf } from '@atlassian/conversation-assistant-content-renderer';
import { StatusCitation } from '../../../ai-answer-dialog/ai-answer-body/ai-answer-result/rendered/status-citation';
var AkReactRenderer = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_.renderer" */'@atlaskit/renderer').then(function (_ref) {
    var ReactRenderer = _ref.ReactRenderer;
    return {
      default: ReactRenderer
    };
  });
});
var fadeIn = null;
var animatedStyles = {
  container: "_y44vtk0h"
};
var unboundAnimatedStyles = {
  container: "_tzy4idpf",
  listItem: "_22jztk0h _cz7ridpf"
};
var StaggeredChild = /*#__PURE__*/memo(function (_ref2) {
  var children = _ref2.children,
    index = _ref2.index;
  // If children is a string longer than 10 characters, split it into 3 parts
  if (typeof children === 'string' && children.length > 10) {
    var chunkSize = Math.ceil(children.length / 3);
    var parts = [children.slice(0, chunkSize), children.slice(chunkSize, chunkSize * 2), children.slice(chunkSize * 2)];
    return /*#__PURE__*/React.createElement(Fragment, null, parts.map(function (part, partIndex) {
      return /*#__PURE__*/React.createElement("span", {
        key: partIndex,
        style: {
          animationDelay: "".concat(index * 200 + partIndex * 100, "ms")
        },
        className: ax([animatedStyles.container, unboundAnimatedStyles.container])
      }, part);
    }));
  }

  // For non-strings or short strings, render normally
  return /*#__PURE__*/React.createElement("span", {
    style: {
      animationDelay: "".concat(index * 200, "ms")
    },
    className: ax([animatedStyles.container, unboundAnimatedStyles.container])
  }, children);
});
StaggeredChild.displayName = 'StaggeredChild';
var StaggeredAnimatedParagraph = /*#__PURE__*/memo(function (_ref3) {
  var children = _ref3.children;
  // Convert children to array to handle staggering
  var childrenArray = React.Children.toArray(children);
  return /*#__PURE__*/React.createElement(Box, null, childrenArray.map(function (child, index) {
    return /*#__PURE__*/React.createElement(StaggeredChild, {
      key: index,
      index: index
    }, child);
  }));
});
StaggeredAnimatedParagraph.displayName = 'StaggeredAnimatedParagraph';
var AnimatedOrderedList = /*#__PURE__*/memo(function (_ref4) {
  var children = _ref4.children,
    props = _objectWithoutProperties(_ref4, _excluded);
  return /*#__PURE__*/React.createElement("ol", _extends({}, props, {
    className: ax([animatedStyles.container, unboundAnimatedStyles.container, unboundAnimatedStyles.listItem])
  }), children);
});
AnimatedOrderedList.displayName = 'AnimatedOrderedList';
var AnimatedBulletedList = /*#__PURE__*/memo(function (_ref5) {
  var children = _ref5.children,
    props = _objectWithoutProperties(_ref5, _excluded2);
  return /*#__PURE__*/React.createElement("ul", _extends({}, props, {
    className: ax([animatedStyles.container, unboundAnimatedStyles.container, unboundAnimatedStyles.listItem])
  }), children);
});
AnimatedBulletedList.displayName = 'AnimatedBulletedList';
var AnimatedHeading = /*#__PURE__*/memo(function (_ref6) {
  var children = _ref6.children,
    props = _objectWithoutProperties(_ref6, _excluded3);
  // Extract heading level from props (h1, h2, h3, etc.)
  var headingLevel = props.level || 1;
  var HeadingTag = "h".concat(headingLevel);
  return /*#__PURE__*/React.createElement(HeadingTag, _extends({}, props, {
    className: ax([animatedStyles.container, unboundAnimatedStyles.container])
  }), children);
});
AnimatedHeading.displayName = 'AnimatedHeading';

// Create stable component references to prevent recreation
var StatusComponent = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement(StatusCitation, props);
});
StatusComponent.displayName = 'StatusComponent';
var MediaComponent = /*#__PURE__*/memo(function () {
  return /*#__PURE__*/React.createElement(Fragment, null);
});
MediaComponent.displayName = 'MediaComponent';
var MediaSingleComponent = /*#__PURE__*/memo(function () {
  return /*#__PURE__*/React.createElement(Fragment, null);
});
MediaSingleComponent.displayName = 'MediaSingleComponent';

// Create stable component references
var StreamingParagraphComponent = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement(StaggeredAnimatedParagraph, props);
});
StreamingParagraphComponent.displayName = 'StreamingParagraphComponent';
var StreamingOrderedListComponent = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement(AnimatedOrderedList, props);
});
StreamingOrderedListComponent.displayName = 'StreamingOrderedListComponent';
var StreamingBulletedListComponent = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement(AnimatedBulletedList, props);
});
StreamingBulletedListComponent.displayName = 'StreamingBulletedListComponent';
var StreamingHeadingComponent = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement(AnimatedHeading, props);
});
StreamingHeadingComponent.displayName = 'StreamingHeadingComponent';

// Create stable nodeComponents objects
var staticNodeComponents = {
  status: StatusComponent,
  media: MediaComponent,
  mediaSingle: MediaSingleComponent
};
var animatedNodeComponents = {
  status: StatusComponent,
  media: MediaComponent,
  mediaSingle: MediaSingleComponent,
  paragraph: StreamingParagraphComponent,
  orderedList: StreamingOrderedListComponent,
  bulletList: StreamingBulletedListComponent,
  heading: StreamingHeadingComponent
};
export function ReactRenderer(_ref7) {
  var markdown = _ref7.markdown,
    _ref7$animateComponen = _ref7.animateComponents,
    animateComponents = _ref7$animateComponen === void 0 ? false : _ref7$animateComponen;
  var docContent = useMemo(function () {
    return encodeAdf(markdown, true);
  }, [markdown]);
  var config = useMemo(function () {
    return {
      document: docContent,
      nodeComponents: animateComponents ? animatedNodeComponents : staticNodeComponents,
      smartLinks: {
        ssr: true
      }
    };
  }, [docContent, animateComponents]);
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Fragment, null)
  }, /*#__PURE__*/React.createElement(AkReactRenderer, config));
}